var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"justgageRefresh"},[_c('vue-justgage',{ref:"g2",staticClass:"gauge",attrs:{"id":"g2","data-value":"100"}}),_c('button',{staticClass:"btn btn-success",attrs:{"href":"javascript:void(0);","id":"g2_refresh"},on:{"click":_vm.refresh}},[_vm._v("Random Refresh")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }